export default __webpack_public_path__ + "static/media/photo1.c237cd68.jpg";